export default "__VITE_ASSET__BK4bh_C9__"